var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"techerDivDisplay"},[_c('title-widge',{staticStyle:{"padding-bottom":"61px"},attrs:{"title":_vm.title,"subTitle":_vm.subTitle}}),_c('div',[(_vm.teacherData.length>0)?_c('common-techer-display-widge',{attrs:{"imgs":_vm.teacherData}}):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }